// Mapa de logos disponibles en assets/images/simm, indexado por nombre de archivo (sin extensión, en mayúsculas)
const logoContext = require.context('@/assets/images/simm', false, /\.svg$/);

const logoMap = {};
logoContext.keys().forEach((key) => {
  const name = key.replace('./', '').replace(/\.svg$/i, '');
  logoMap[name.toUpperCase()] = logoContext(key);
});

// La API solo expone el nombre comercial completo de la aseguradora (p.ej. "AXA Seguros S.A. de C.V."),
// mientras que los logos se nombran con la clave corta (p.ej. "AXA.svg"). Se intenta primero una
// coincidencia exacta y, si falla, se usa la primera palabra del nombre como clave.
export function getAseguradoraLogo(value) {
  if (!value) return null;
  const trimmed = String(value).trim();
  if (!trimmed) return null;

  const exact = logoMap[trimmed.toUpperCase()];
  if (exact) return exact;

  const firstWord = trimmed.split(/\s+/)[0];
  return logoMap[firstWord.toUpperCase()] || null;
}
